import React, { memo } from 'react'

import SwitchControl from '../switchControl/SwitchControl'

const MonthlyYearlySwitch = ({ t, checked, onChange, disabledSwitch }) => {
  return (
    <SwitchControl
      disabled={disabledSwitch}
      checked={checked}
      onChange={onChange}
      leftLabel={t('billing.monthly-payment')}
      rightLabel={t('billing.yearly-payment')}
    />
  )
}

export default memo(MonthlyYearlySwitch)
